import Vue from 'vue';

export default [
    {
        pathId: 'rmc',
        component: 'rmc-conferences',
        title: 'RMC Conferences',
        icon: 'fa-presentation',
        size: 'md',
        loading: true
    }, {
        pathId: 'rmc-c',
        component: 'rmc-conference',
        title: 'Conference',
        icon: 'fa-presentation',
        size: 'md',
        props: ['confId'],
        loading: true
    }, {
        pathId: 'rmc-cn',
        component: 'rmc-new-conference',
        title: 'New Conference',
        icon: 'fa-plus',
        size: 'lg'
    }, {
        pathId: 'rmc-ce',
        component: 'rmc-edit-conference',
        title: 'Edit Conference',
        icon: 'fa-pencil',
        size: 'lg',
        props: ['confId'],
        loading: true
    }, {
        pathId: 'rmc-r',
        component: 'rmc-registrations',
        title: 'Registrations',
        icon: 'fa-users',
        size: 'sm',
        props: ['confId', 'type', 'query'],
        loading: true
    }, {
        pathId: 'rmc-ss',
        component: 'rmc-sessions',
        title: 'Sessions',
        icon: 'fa-users-class',
        size: 'md',
        props: ['confId'],
        loading: true
    }, {
        pathId: 'rmc-s',
        component: 'rmc-session',
        title: 'Session',
        icon: 'fa-users-class',
        size: 'md',
        props: ['confId', 'sessionId'],
        loading: true
    }, {
        pathId: 'rmc-sn',
        component: 'rmc-new-session',
        title: 'New Session',
        icon: 'fa-plus',
        size: 'lg',
        props: ['confId']
    }, {
        pathId: 'rmc-se',
        component: 'rmc-edit-session',
        title: 'Session',
        icon: 'fa-users-class',
        size: 'lg',
        props: ['confId', 'sessionId'],
        loading: true
    }, {
        pathId: 'rmc-ssqs',
        component: 'rmc-session-survey-questions',
        title: 'Survey Questions',
        icon: 'fa-question-circle',
        size: 'sm',
        props: ['confId', 'sessionId'],
        loading: true
    }, {
        pathId: 'rmc-ssqn',
        component: 'rmc-new-session-survey-question',
        title: 'New Survey Question',
        icon: 'fa-plus',
        size: 'md',
        props: ['sessionId']
    }, {
        pathId: 'rmc-ssqe',
        component: 'rmc-edit-session-survey-question',
        title: 'Edit Survey Question',
        icon: 'fa-pencil',
        size: 'md',
        props: ['sessionId', 'questionId'],
        loading: true
    }, {
        pathId: 'rmc-f',
        component: 'rmc-fees',
        title: 'Registration Fees',
        icon: 'fa-usd-square',
        size: 'sm',
        props: ['confId'],
        loading: true
    }, {
        pathId: 'rmc-fn',
        component: 'rmc-new-fee',
        title: 'New Registration Fee',
        icon: 'fa-plus',
        props: ['confId'],
        size: 'md'
    }, {
        pathId: 'rmc-fe',
        component: 'rmc-edit-fee',
        title: 'Edit Registration Fee',
        icon: 'fa-pencil',
        props: ['feeId', 'confId'],
        size: 'md'
    }, {
        pathId: 'rmc-q',
        component: 'rmc-questions',
        title: 'Registration Questions',
        icon: 'fa-question-circle',
        size: 'sm',
        props: ['confId'],
        loading: true
    }, {
        pathId: 'rmc-qn',
        component: 'rmc-new-question',
        title: 'New Registration Question',
        icon: 'fa-plus',
        size: 'md',
        props: ['confId']
    }, {
        pathId: 'rmc-qe',
        component: 'rmc-edit-question',
        title: 'Edit Registration Question',
        icon: 'fa-pencil',
        size: 'md',
        props: ['confId','questionId']
    }, {
        pathId: 'rmc-d',
        component: 'rmc-discounts',
        title: 'Discounts',
        icon: 'fa-badge-dollar',
        size: 'sm',
        props: ['confId'],
        loading: true
    }, {
        pathId: 'rmc-dn',
        component: 'rmc-new-discount',
        title: 'New Registration Discount',
        icon: 'fa-plus',
        props: ['confId'],
        size: 'md'
    }, {
        pathId: 'rmc-de',
        component: 'rmc-edit-discount',
        title: 'Edit Registration Discount',
        icon: 'fa-pencil',
        props: ['confId', 'discountId'],
        size: 'md',
        loading: true
    }
];

Vue.component('rmc-conferences', () => import('@/cards/RMC/Conferences'));
Vue.component('rmc-conference', () => import('@/cards/RMC/conferences/Details'));
Vue.component('rmc-new-conference', () => import('@/cards/RMC/conferences/NewConference'));
Vue.component('rmc-edit-conference', () => import('@/cards/RMC/conferences/EditConference'));
Vue.component('rmc-sessions', () => import('@/cards/RMC/conferences/Sessions'));
Vue.component('rmc-session', () => import('@/cards/RMC/conferences/Session'));
Vue.component('rmc-new-session', () => import('@/cards/RMC/conferences/NewSession'));
Vue.component('rmc-edit-session', () => import('@/cards/RMC/conferences/EditSession'));
Vue.component('rmc-session-survey-questions', () => import('@/cards/RMC/conferences/SessionSurveyQuestions'));
Vue.component('rmc-new-session-survey-question', () => import('@/cards/RMC/conferences/NewSessionSurveyQuestion'));
Vue.component('rmc-edit-session-survey-question', () => import('@/cards/RMC/conferences/EditSessionSurveyQuestion'));
Vue.component('rmc-fees', () => import('@/cards/RMC/conferences/Fees'));
Vue.component('rmc-new-fee', () => import('@/cards/RMC/conferences/NewFee'));
Vue.component('rmc-edit-fee', () => import('@/cards/RMC/conferences/EditFee'));
Vue.component('rmc-registrations', () => import('@/cards/RMC/conferences/Registrations'));
Vue.component('rmc-questions', () => import('@/cards/RMC/conferences/Questions'));
Vue.component('rmc-new-question', () => import('@/cards/RMC/conferences/NewQuestion'));
Vue.component('rmc-edit-question', () => import('@/cards/RMC/conferences/EditQuestion'));
Vue.component('rmc-discounts', () => import('@/cards/RMC/conferences/Discounts'));
Vue.component('rmc-new-discount', () => import('@/cards/RMC/conferences/NewDiscount'));
Vue.component('rmc-edit-discount', () => import('@/cards/RMC/conferences/EditDiscount'));
